export function capitalizeFirstLetter(data: string) {
  return data?.charAt(0).toUpperCase() + data?.slice(1);
}
